import * as _chains from "viem/chains";

export const chains = _chains as unknown as Record<string, _chains.Chain>;
